<script>
    import {onMount} from 'svelte'
    import {locale, language } from '../../languages'
    import {postResource,logout, getResource} from '../../service'
    import * as yup from 'yup'

    
    let email = null
    let user 
    // let schema = yup.object().email().required()

    onMount(()=>{
        getResource('profile')
        .subscribe(p=>{
            p.then(data=>{ 
                
                user = data 
                email  = data.email
                
            })
        })

    })

    function handleSubmit() {
        
        postResource('changeemail',{email:email})
        .subscribe( p => {
            p.then(data=>{
                console.log(data)
                $$props.router.navigate('settings')
            }).catch(err=>{
                console.log(err)
            })
        })
    }


    function cancel(){
        $$props.router.navigate('settings')
    }
    
</script>

<div class="w-full h-full">
        <form  on:submit|preventDefault={handleSubmit} class="flex flex-col gap-3 p-4 mt-4">
            <div>
                <label  for="email" class="mb-2 block px-2 font-bold">
                    <span>{$language.label_email}</span>
    
                </label>
                <input name="email" type="text" bind:value={email} class="w-full p-1 rounded-full border-2 border-green-400">
            </div>
            
            <div class="flex flex-row gap-4 mt-10">
                <button  on:click={cancel}
                    class=" text-white text-center p-2 font-bold rounded-full  w-full bg-gray-400">
                    {$language.btn_cancel}                    
                </button>
                <button  type="submit" 
                class=" text-white text-center font-bold rounded-full  w-full bg-green-400">
                {$language.btn_save}                    
            </button>
            </div>
            
        </form>

</div>
